module.exports = {
    Action: {
        reorder: 'Reorder',
        delete: 'Delete'
    },
    Projects: {
        add: 'New order',
        projectName: 'Patient name'
    },
    ProjectDetails: {
      attachments: 'Images',
      additionalFiles: 'Additional Files',
      shippingType: 'Shipping method after completion',
    },
    OrderDetails: {
        errorCouldNotReorder: 'Reorder failed'
    },
    Dashboard: {
        title: 'Dashboard',
        NewProduction: 'New production',
        NewDesignProduction: 'New design & production',
        NewDesign: 'New design service',
        CreateNewCase: 'Create new case/project',
        ProductionDescription: 'Submit a new production order to have your already designed construction produced by us. Simply upload your design data and we will take care of the rest.',
        DesignProductionDescription: 'Start a new design and send us your model data either physically or digitally - we will take care of the rest to ensure optimal treatment for your patients.',
        DesignDescription: 'Entrust us with your implant planning: Upload patient data, and we will create a personalized treatment plan for precise, secure results.'
    }
};